import { useContext, memo } from 'react';
import {
    Box,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar,
    IconButton,
    Grid,
    Stack,
    Badge,
    Tooltip,
} from '@mui/material';
import {
    CardMembership as CardMembershipIcon,
    WorkspacePremium as WorkspacePremiumIcon,
    ContentPasteOff as ContentPasteOffIcon,
    PendingActions as PendingActionsIcon,
    Delete as DeleteIcon,
    HomeRepairService as HomeRepairServiceIcon,
    Visibility as VisibilityIcon,
    DriveFileRenameOutline as DriveFileRenameOutlineIcon,
    WorkHistory as WorkHistoryIcon,
} from '@mui/icons-material';

import Context from '../context';
import DivSpinner from '../../../components/divSpinner';
import { deleteSkills } from '../service';

// ✅ Extracted small reusable subcomponent for clarity
const SkillActions = memo(({ skill, dispatch }) => (
    <Box display="flex" alignItems="center">
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mr: 5 }}>
            <Tooltip title="Tradespersons with Approved Certificates" arrow>
                <Badge badgeContent={`${skill.skills_document_status_counts.approved}`} color="success">
                    <WorkspacePremiumIcon color="action" />
                </Badge>
            </Tooltip>
            <Tooltip title="Tradespersons with Rejected Certificates" arrow>
                <Badge badgeContent={`${skill.skills_document_status_counts.rejected}`} color="error">
                    <ContentPasteOffIcon color="action" />
                </Badge>
            </Tooltip>
            <Tooltip title="Tradespersons with Awaiting Certificates" arrow>
                <Badge badgeContent={`${skill.skills_document_status_counts.awaiting}`} color="warning">
                    <PendingActionsIcon color="action" />
                </Badge>
            </Tooltip>
        </Stack>

        <Stack direction="row" spacing={-1} alignItems="center">
            <IconButton onClick={() => dispatch({ type: 'SET_SELECTED_SKILLS', selected_skills: skill })}>
                <VisibilityIcon />
            </IconButton>

            <IconButton
                onClick={() =>
                    dispatch({
                        type: 'IS_SHOW_CERTIFICATE_TYPES',
                        is_show_certificate_types: true,
                        selected_skills: skill,
                    })
                }
            >
                <CardMembershipIcon />
            </IconButton>

            <IconButton
                onClick={() =>
                    dispatch({
                        type: 'IS_SHOW_EDIT_SKILLS',
                        is_show_edit_skills: true,
                        selected_skills: skill,
                    })
                }
            >
                <DriveFileRenameOutlineIcon />
            </IconButton>

            <IconButton 
                onClick={() =>
                    dispatch({
                        type: 'IS_SHOW_SKILLS_JOB_NEED_TIME',
                        show_skills_job_need_time: true,
                        selected_skills: skill,
                    })
                }
            >
                <WorkHistoryIcon />
            </IconButton>

            <IconButton onClick={() => deleteSkills(skill.skill_id, dispatch)}>
                <DeleteIcon />
            </IconButton>
        </Stack>
    </Box>
));

const SkillItem = memo(({ skill, dispatch }) => (
    <ListItem
        secondaryAction={<SkillActions skill={skill} dispatch={dispatch}/>}
    >
        <ListItemAvatar>
            <Avatar>
                <HomeRepairServiceIcon />
            </Avatar>
        </ListItemAvatar>
        <ListItemText
            primary={skill.skill_name}
            secondary={`SERVICE TYPE COUNT: ${skill.sub_skill_count}`}
        />
    </ListItem>
));

function SkillsList() {
    const { state, dispatch } = useContext(Context);
    const { is_loading, skills } = state;

    if (is_loading) {
        return (
            <div style={{ height: `${window.innerHeight - 387}px` }}>
                <DivSpinner />
            </div>
        );
    }

    return (
        <Box sx={{ flexGrow: 1, mx: 4 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <List>
                        {skills.map((skill) => (
                            <SkillItem key={skill.skill_id} skill={skill} dispatch={dispatch}/>
                        ))}
                    </List>
                </Grid>
            </Grid>
        </Box>
    );
}

export default memo(SkillsList);